import angular from 'angular';
import { UpdatePlanModalComponent } from './UpdatePlanModal/UpdatePlanModal.component';
import { UpdateVersionModal } from './UpdateVersionModal/UpdateVersionModal.component';
import { TableRowComponent } from './UpdateVersionModal/tableRow/tableRow.component';
export const studioComponents = angular
    .module('studioComponents', [])
    .component('updatePlanModal', UpdatePlanModalComponent)
    .component('updateVersionModal', UpdateVersionModal)
    .component('tableRowComponent', TableRowComponent)
    .name;
